// Firebase App (the core Firebase SDK) is always required and must be listed first
import * as firebase from "firebase/app";
import { getAuth, signInWithEmailAndPassword, onAuthStateChanged, createUserWithEmailAndPassword } from "firebase/auth";
import { getStorage, ref, uploadBytes, getDownloadURL  } from "firebase/storage";

/*var firebaseConfig = {
    apiKey: "AIzaSyDpV1z7_61TSRkQGcCdI9gJvVhYipCib0w",
    authDomain: "koas-cochabamba.firebaseapp.com",
    projectId: "koas-cochabamba",
    storageBucket: "koas-cochabamba.appspot.com",
    messagingSenderId: "608105440953",
    appId: "1:608105440953:web:d4acf98d9a322512eb9d68",
    measurementId: "G-JSWHE3GLL8"
};*/
var firebaseConfig = {
    apiKey: "AIzaSyAAe0EIfs2l1J2eqiLzZLBo1GUXt3D9PLk",
    authDomain: "postulacion-docente.firebaseapp.com",
    projectId: "postulacion-docente",
    storageBucket: "postulacion-docente.appspot.com",
    messagingSenderId: "1016574997981",
    appId: "1:1016574997981:web:2af452ce1cd2a63b6bf234",
    measurementId: "G-GB5J1XMP5S"
};
  
export const firebaseApp=firebase.initializeApp(firebaseConfig);
export const storage = getStorage(firebaseApp);
export const auth = getAuth();
//const analytics = getAnalytics(app);

function makeid(length) {
    var result           = '';
    var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for ( var i = 0; i < length; i++ ) {
      result += characters.charAt(Math.floor(Math.random() * 
 charactersLength));
   }
   return result;
}

export async function uploadFile(file) {
    const storageRef = ref(storage,makeid(15)+".pdf");
    // 'file' comes from the Blob or File API
    return uploadBytes(storageRef, file).then((snapshot) => {
        return getDownloadURL(storageRef).then((url) => {
            console.log("***********************");
            console.log(url);
            return url;
          })
          .catch((error) => {
              return error.message;
            // Handle any errors
          });
    });
}

export async function getCurrentUser() {
    return new Promise((resolve,reject)=> {
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            if (user) {
                resolve(user);
            } else {
                resolve(null);                
            }
            unsubscribe();
        });
    }) 
}

export async function loginUser(email,password) {
    return signInWithEmailAndPassword(auth,email, password)
    .then((userCredential) => {
      // Signed in
      var user = userCredential.user;
      return [true,user]
    })
    .catch((error) => {
      //var errorCode = error.code;
      var errorMessage = error.message;
      return [false,errorMessage]
    });
}

export async function createUser(email, password) {
    return createUserWithEmailAndPassword(auth, email, password)
    .then((userCredential) => {
        const user = userCredential.user;
        return [true,user]
    })
    .catch((error) => {
        const errorCode = error.code;
        const errorMessage = error.message;
        return [false,errorMessage]
    });
}